import HeaderFooterLayout from 'layouts/HeaderFooterLayoutAdmin';
import React from 'react';
import AdminHome from '../components/AdminPanel/Home';

const AdminHomePage = () => {
  return (
    <div>
      <HeaderFooterLayout>
        <AdminHome />
      </HeaderFooterLayout>
    </div>
  );
};

export default AdminHomePage;
